export default __webpack_public_path__ + "assets/1851c74f7670296e9c53f87ad74983bf/loading.svg";